/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../types/definitions/vendor/graphql-schema.d";
import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type UtmPromoSessionCreateMutationVariables = Types.Exact<{
  input: Types.UtmPromoSessionCreateInput;
}>;
export type UtmPromoSessionCreateMutation = {
  __typename?: "Mutation";
  utmPromoSessionCreate?: {
    __typename: "UtmPromoSessionNotFound";
    empty?: boolean | null;
  } | {
    __typename: "UtmPromoSessionSuccess";
    content?: {
      __typename?: "UtmPromoSessionContent";
      bannerMessage: string;
      bannerVariant: Types.ModeBannerSlimVariant;
      cta: {
        __typename?: "CallToAction";
        actionType: Types.CallToActionTypes;
        url: string;
        appUrl?: string | null;
        label: {
          __typename?: "I18nCopy";
          key: string;
          text: string;
        };
      };
    } | null;
  } | null;
};
export const UtmPromoSessionCreateDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "UtmPromoSessionCreate"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "input"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "UtmPromoSessionCreateInput"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "utmPromoSessionCreate"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "input"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "input"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "__typename"
            }
          }, {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "UtmPromoSessionSuccess"
              }
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "content"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "bannerMessage"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "bannerVariant"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "cta"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "actionType"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "url"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "appUrl"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "label"
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "key"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "text"
                            }
                          }]
                        }
                      }]
                    }
                  }]
                }
              }]
            }
          }, {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "UtmPromoSessionNotFound"
              }
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "empty"
                }
              }]
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export type UtmPromoSessionCreateMutationFn = Apollo.MutationFunction<UtmPromoSessionCreateMutation, UtmPromoSessionCreateMutationVariables>;

/**
 * __useUtmPromoSessionCreateMutation__
 *
 * To run a mutation, you first call `useUtmPromoSessionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUtmPromoSessionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [utmPromoSessionCreateMutation, { data, loading, error }] = useUtmPromoSessionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUtmPromoSessionCreateMutation(baseOptions?: Apollo.MutationHookOptions<UtmPromoSessionCreateMutation, UtmPromoSessionCreateMutationVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useMutation<UtmPromoSessionCreateMutation, UtmPromoSessionCreateMutationVariables>(UtmPromoSessionCreateDocument, options);
}
export type UtmPromoSessionCreateMutationHookResult = ReturnType<typeof useUtmPromoSessionCreateMutation>;
export type UtmPromoSessionCreateMutationResult = Apollo.MutationResult<UtmPromoSessionCreateMutation>;
export type UtmPromoSessionCreateMutationOptions = Apollo.BaseMutationOptions<UtmPromoSessionCreateMutation, UtmPromoSessionCreateMutationVariables>;